import { render, staticRenderFns } from "./infographies-block.vue?vue&type=template&id=581392f1&"
import script from "./infographies-block.vue?vue&type=script&lang=js&"
export * from "./infographies-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports